import { NoCampaign, ResolvedCampaign, ResolvedProgramSummary, UnknownCampaign } from '../../types';
import { useIsSmallerThanTablet } from '../../../responsive/hooks/hooks';
import { Form } from 'react-bootstrap';
import { CampaignSelect } from '../CampaignSelect';
import { ModalDropdownMenuZIndex } from '../../util';
import { DivButton } from '../../../commons/components/DivButton';
import { EyeIcon } from '../../../assets/icons';
import React from 'react';

const isShowDetailsAvailable = (
  value: ResolvedProgramSummary | null,
  onShowCampaignClick: ((v: ResolvedCampaign) => void) | null
) => onShowCampaignClick && value && value.id !== NoCampaign.id && value.id !== UnknownCampaign.id;

export const ProgramEditCampaign = ({
  setValue,
  value,
  disabled,
  required,
  hasError,
  campaigns,
  onShowCampaignClick,
}: {
  setValue: (s: ResolvedProgramSummary | null) => void;
  value: ResolvedProgramSummary | null;
  disabled: boolean;
  required: boolean;
  hasError: boolean;
  campaigns: ResolvedCampaign[];
  onShowCampaignClick: ((v: ResolvedCampaign) => void) | null;
}) => {
  const isSmallerThanTablet = useIsSmallerThanTablet();
  return (
    <div>
      <Form.Group controlId="campaign" className="growegy-form__row">
        <label className="growegy-form__label">Campaign</label>
        <div className="d-flex">
          <div>
            <CampaignSelect
              campaigns={campaigns}
              initialValue={value}
              onValueChange={(v) => setValue(v)}
              disabled={disabled}
              hasError={hasError}
              isRequired={required}
              dataTestPrefix="program-campaign-select"
              menuZIndex={ModalDropdownMenuZIndex}
            />
          </div>
          {isShowDetailsAvailable(value, onShowCampaignClick) && !isSmallerThanTablet && (
            <DivButton
              isGray={true}
              className="programs-edit__campaign-details-button"
              text="View details"
              dataTest="programs-edit__campaign-details-button"
              onClick={() => {
                if (value && onShowCampaignClick) onShowCampaignClick(value);
              }}
            />
          )}
          {isShowDetailsAvailable(value, onShowCampaignClick) && isSmallerThanTablet && (
            <DivButton
              icon={<EyeIcon />}
              isGray={true}
              className="programs-edit__campaign-details-button"
              dataTest="programs-edit__campaign-details-button"
              onClick={() => {
                if (value && onShowCampaignClick) onShowCampaignClick(value);
              }}
            />
          )}
        </div>
      </Form.Group>
    </div>
  );
};
